var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5833 20L13.4722 14.8889C12.7685 15.463 11.9821 15.9028 11.1131 16.2083C10.244 16.5139 9.31778 16.6667 8.33444 16.6667C5.98185 16.6667 4.00463 15.8594 2.40278 14.2447C0.800926 12.6301 0 10.6596 0 8.33333C0 5.98148 0.800926 4.00463 2.40278 2.40278C4.00463 0.800926 5.97685 0 8.31944 0C10.662 0 12.6389 0.800926 14.25 2.40278C15.8611 4.00463 16.6667 5.98185 16.6667 8.33444C16.6667 9.31778 16.5139 10.244 16.2083 11.1131C15.9028 11.9821 15.463 12.7685 14.8889 13.4722L20 18.5833L18.5833 20ZM8.33333 14.6667C10.1111 14.6667 11.6111 14.0556 12.8333 12.8333C14.0556 11.6111 14.6667 10.1065 14.6667 8.31944C14.6667 6.53241 14.0556 5.03241 12.8333 3.81944C11.6111 2.60648 10.1111 2 8.33333 2C6.53704 2 5.03241 2.60648 3.81944 3.81944C2.60648 5.03241 2 6.53241 2 8.31944C2 10.1065 2.60648 11.6111 3.81944 12.8333C5.03241 14.0556 6.53704 14.6667 8.33333 14.6667Z",
    fill: "#EE750A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.198dcb0274341a6f6942809b376d8172.svg";
export { ForwardRef as ReactComponent };